import { render, staticRenderFns } from "./BarangaysList.vue?vue&type=template&id=640a707e"
import script from "./BarangaysList.vue?vue&type=script&lang=js"
export * from "./BarangaysList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports